import { formatEther as ethersFormatEther } from 'ethers';

export const formatEther = (
  value: bigint | number | string,
  decimal: number,
): string => {
  let priceInEth: string;
  if (typeof value === 'bigint') {
    priceInEth = ethersFormatEther(value);
  } else {
    priceInEth = value.toString();
  }

  const numberValue = Number(priceInEth);
  
  if (isNaN(numberValue)) {
    return '0';
  }

  // Use toFixed to handle rounding and padding consistently
  return numberValue.toFixed(decimal);
};
